import Vue from "vue";
import VueRouter from "vue-router";
import BasicLayout from "@/layouts/BasicLayout";
import InformationExposure from "@/views/information-exposure/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: BasicLayout,
    children: [
      {
        path: "/",
        redirect: "/home",
      },
      {
        path: "/home",
        name: "homePage",
        component: () =>
          import(/* webpackChunkName: "home-page" */ "../views/Home.vue"),
        meta: {
          title: "",
        },
      },
      {
        path: "/information_exposure",
        name: "informationExposure",
        component: InformationExposure,
        children: [
          {
            path: "/information_exposure",
            redirect: "/information_exposure/company_information",
          },
          {
            path: "company_information",
            name: "company-information",
            component: () =>
              import(
                /* webpackChunkName: "company-information" */ "../views/information-exposure/CompanyInformation.vue"
              ),
            meta: {
              title: "公司概况",
            },
          },
          {
            path: "official_notices",
            name: "official-notices",
            component: () =>
              import(
                /* webpackChunkName: "official-notices" */ "../views/information-exposure/OfficialNotices.vue"
              ),
            meta: {
              title: "",
            },
          },
          {
            path: "certifications",
            name: "certifications",
            component: () =>
              import(
                /* webpackChunkName: "certifications" */ "../views/information-exposure/Certifications.vue"
              ),
            meta: {
              title: "官方公告",
            },
          },
          {
            path: "insurance_products",
            name: "insurance-products",
            component: () =>
              import(
                /* webpackChunkName: "insurance-products" */ "../views/information-exposure/InsuranceProducts.vue"
              ),
            meta: {
              title: "保险产品",
            },
          },
          {
            path: "cooperative_insurance_companies",
            name: "cooperative-insurance-companies",
            component: () =>
              import(
                /* webpackChunkName: "cooperative-insurance-companies" */ "../views/information-exposure/CooperativeInsuranceCompanies"
              ),
            meta: {
              title: "合作保险公司",
            },
          },
          {
            path: "cooperative_agents",
            name: "cooperative-agents",
            component: () =>
              import(
                /* webpackChunkName: "cooperative-agents" */ "../views/information-exposure/CooperativeAgents"
              ),
            meta: {
              title: "合作中介机构",
            },
          },
          {
            path: "cooperative_platforms",
            name: "cooperative-platforms",
            component: () =>
              import(
                /* webpackChunkName: "cooperative-platforms" */ "../views/information-exposure/CooperativePlatforms"
              ),
            meta: {
              title: "合作网络平台",
            },
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => {
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;
